
// global
export const LOADED_SUCCESS = 'LOADED_SUCCESS'
export const LOADING_START = 'LOADING_START'
export const CHAGE_LOADING_MESAGE = 'CHAGE_LOADING_MESAGE'
export const NOTIFY_ERRORS = 'NOTIFY_ERRORS'
export const RESET_STATE = 'RESET_STATE'
export const LOAD_US_STATES = 'LOAD_US_STATES'
export const LOAD_ROLES = 'LOAD_ROLES'
export const LOAD_MAKES = 'LOAD_MAKES'
export const LOAD_MODELS = 'LOAD_MODELS'
export const LOAD_FUEL_TYPES = 'LOAD_FUEL_TYPES'
export const LOAD_ENHANCEMENTS = 'LOAD_ENHANCEMENTS'
export const LOAD_STATUS = 'LOAD_STATUS'
export const SET_SELECTED_NOTIFICATION = 'SET_SELECTED_NOTIFICATION'
export const LOAD_SELECTEDSTATES = 'LOAD_SELECTEDSTATES'
export const LOAD_ACCEPTEDDATES = 'LOAD_ACCEPTEDDATES'
export const SET_SELECTED_CALL_CODE = 'SET_SELECTED_CALL_CODE'
export const SET_LAST_NAVIGATION = 'SET_LAST_NAVIGATION'
export const SET_MITEL = 'SET_MITEL'
export const MITEL_LOGIN = 'MITEL_LOGIN'
export const MITEL_LOGIN_SUCCESS = 'MITEL_LOGIN_SUCCESS'
export const MITEL_LOGOUT = 'MITEL_LOGOUT'
export const MITEL_LOGIN_SKIP = 'MITEL_LOGIN_SKIP'
export const SET_LIVEVOX = 'SET_LIVEVOX'
export const LIVEVOX_LOGIN = "LIVEVOX_LOGIN"
export const LIVEVOX_LOGIN_SUCCESS = 'LIVEVOX_LOGIN_SUCCESS'
export const LIVEVOX_LOGIN_SKIP = 'LIVEVOX_LOGIN_SKIP'
export const LIVEVOX_LOGOUT = 'LIVEVOX_LOGOUT'
export const VERINT_LOGIN_SUCCESS = 'VERINT_LOGIN_SUCCESS'
export const SET_ENABLE_CLIPBOARD_COPY_ON_OUTBOUND_DIAL = 'SET_ENABLE_CLIPBOARD_COPY_ON_OUTBOUND_DIAL'
// // wizard step - quotes
// export const LOAD_MODELS_BY_MAKE_AND_YEAR = 'LOAD_MODELS_BY_MAKE_AND_YEAR'
// export const CHECK_VIN_INFORMATION = 'CHECK_VIN_INFORMATION'
// export const SET_QUOTE_LIST = 'SET_QUOTE_LIST'
// export const ADD_NEW_QUOTE = 'ADD_NEW_QUOTE'
// export const UPDATE_QUOTE = 'UPDATE_QUOTE'

// // third party - quotes
// export const DECLINE_INITIAL_QUOTE = 'DECLINE_INITIAL_QUOTE'
// export const DOBULE_DECLINE_INITIAL_QUOTE = 'DOBULE_DECLINE_INITIAL_QUOTE'
// export const SET_CALLBACK_QUOTE = 'SET_CALLBACK_QUOTE'
// export const SET_ACCEPTED_QUOTE = 'SET_ACCEPTED_QUOTE'
// export const SET_QUOTE_STATUS = 'SET_QUOTE_STATUS'

// state laws
//export const SET_SELECTED_STATE = 'SET_SELECTED_STATE';





// WEBPACK FOOTER //
// ./src/store/mutation-types.js